(function () {
  /* ---------------------------------------------------------------------
     Meta Lead on code claim (added 2026-10-23).

     The storefront has no fbq of its own: the Meta pixel runs inside
     Shopify's web-pixel sandbox, which cannot see this page's DOM. So the
     base code is loaded here with autoConfig off (no automatic button or
     form events) and PageView is never sent from here, which leaves the
     sandbox copy as the only source of PageView. Nothing is duplicated.

     Lead fires at most once per page view, from whichever capture wins:
       native   - the {% form 'customer' %} gate, which returns with
                  customer_posted=true in the query string
       app-form - the Shopify Forms block on the challenge page. That app
                  renders its form inside the shadow root of a
                  <shopify-forms-embed> element and submits over AJAX, so
                  there is no URL change and nothing to see in the light
                  DOM. The shadow root is open (mode: 'open' in the app's
                  loader), so it can be watched from here: once an email
                  input has been seen inside it, that input going away or
                  becoming invisible is the success state. That holds
                  whatever the app renders and whatever the copy says.
     Every tracking call is wrapped: this must never break the page.
     --------------------------------------------------------------------- */
  var AZ_PIXEL = '1108635201848871';
  var leadSent = false;

  function fbqReady() {
    if (!window.fbq) {
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
        t = b.createElement(e); t.async = !0; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('set', 'autoConfig', false, AZ_PIXEL);
      window.fbq('init', AZ_PIXEL);
    }
    return window.fbq;
  }

  function lead(source) {
    if (leadSent) return;
    leadSent = true;
    try {
      fbqReady()('trackSingle', AZ_PIXEL, 'Lead', {
        content_name: '8-day challenge code',
        content_category: source
      });
    } catch (e) { /* tracking never breaks the page */ }
  }

  function visibleEmailInput(scope) {
    if (!scope) return null;
    var inputs = scope.querySelectorAll('input[type="email"], input[name*="email" i]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (el.offsetParent !== null || el.getClientRects().length) return el;
    }
    return null;
  }

  /* Watch one scope (a shadow root, or a plain element) for the success
     state: an email input was there, and now it is gone or hidden. */
  function watchScope(scope, source) {
    if (!scope || scope.__azLeadWatched) return;
    scope.__azLeadWatched = true;
    var sawInput = !!visibleEmailInput(scope);
    var obs = new MutationObserver(function () {
      if (leadSent) { obs.disconnect(); return; }
      var input = visibleEmailInput(scope);
      if (!sawInput) { sawInput = !!input; return; }
      if (!input) { obs.disconnect(); lead(source); }
    });
    try {
      obs.observe(scope, { childList: true, subtree: true, attributes: true });
    } catch (e) { /* a scope that cannot be observed is simply skipped */ }
  }

  /* The app block renders async, so look for it for a while after load. */
  function findAppForms() {
    var hosts = document.querySelectorAll('shopify-forms-embed, [data-form-root] *');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) watchScope(hosts[i].shadowRoot, 'app-form');
    }
    var roots = document.querySelectorAll('[data-forms-id]');
    for (var j = 0; j < roots.length; j++) {
      if (visibleEmailInput(roots[j])) watchScope(roots[j], 'app-form');
    }
  }

  function showSent(group) {
    var form = group.querySelector('form[data-az-capture]');
    var note = group.querySelector('[data-az-note]');
    var sent = group.querySelector('[data-az-sent]');
    if (form) { form.hidden = true; form.style.display = 'none'; }
    if (note) note.hidden = true;
    if (sent) { sent.hidden = false; sent.setAttribute('role', 'status'); sent.setAttribute('tabindex', '-1'); sent.focus(); }
  }
  function wire(form) {
    if (form.dataset.azCaptureReady === 'true') return;
    form.dataset.azCaptureReady = 'true';
    form.addEventListener('submit', function (event) {
      var input = form.querySelector('input[type="email"]');
      if (input && !input.checkValidity()) { event.preventDefault(); input.reportValidity(); }
      // Otherwise the form posts natively to Shopify's /contact customer endpoint.
    });
  }
  function init(root) { (root || document).querySelectorAll('form[data-az-capture]').forEach(wire); }
  init(document);
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    document.querySelectorAll('[data-az-capture-group]').forEach(showSent);
    var gate = document.querySelector('[data-az-gate]');
    if (gate && window.location.hash === '#az-gate') gate.hidden = false;
    lead('native');
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); findAppForms(); });

  findAppForms();
  var tries = 0;
  var poll = setInterval(function () {
    findAppForms();
    if (++tries > 120 || leadSent) clearInterval(poll);
  }, 500);
})();
